// extracted by mini-css-extract-plugin
export default {"edit":"Header_edit__aNPTU","cancel":"Header_cancel__uKWtt"};